import React from 'react';

import Badge, { BadgeName } from '../index';
import { Container, MoreUsers } from '../styles';

export interface Props {
  itemsBadges: BadgeName[];
  unGroup?: boolean;
  lineGroup?: boolean;
}

const GroupBadges = ({ itemsBadges, unGroup, lineGroup }: Props) => {
  const numberOfUsers = itemsBadges.length;
  const numberOfUserIcons = numberOfUsers > 3 ? 3 : numberOfUsers;

  const renderQuantity = () => {
    if (unGroup) {
      return itemsBadges.length > 1 && <MoreUsers unGroup>{`+${numberOfUsers - 1}`}</MoreUsers>;
    }
    return itemsBadges.length > 3 && <MoreUsers lineGroup>{`+${numberOfUsers - 3}`}</MoreUsers>;
  };

  return (
    <Container>
      {unGroup && itemsBadges.length ? (
        <Badge badgeText={itemsBadges.first()?.name} />
      ) : (
        itemsBadges
          .slice(0, numberOfUserIcons)
          .map((item, index) => <Badge lineGroup={lineGroup} key={item.id} index={index} textStream={item} />)
      )}
      {renderQuantity()}
    </Container>
  );
};

export default GroupBadges;
